import css from 'styled-jsx/css';

const staticStyles = css.global`
  .ChangePaymentStatusForm {
    &__fieldWrapper {
      margin-top: 24px;
      display: flex;
      gap: 10px;

      .BaseSelectField {
        flex: 1;
      }
    }

    &__submit-btn {
      height: 54px;
      background: #f2b233 !important;

      .DefaultButton__text {
        color: #fff;
      }
    }

    &__checkbox {
      &-wrapper {
        display: flex;
        align-items: center;
        gap: 12px;
        margin-bottom: 24px;

        .Checkbox__label {
          color: #999 !important;
          font-size: 15px !important;
        }
      }
    }

    &__close-btn {
      display: block !important;
      margin: 0 auto;
      border-color: #c7c8cc !important;

      .DefaultButton__text {
        color: #333;
      }
    }
  }
`;

export { staticStyles };
